import type {userState} from './types'

import {atom, useAtomValue} from 'jotai'

import store from '..'

const userAtom = atom<userState>((get) => get(store).user)

export const useUserSelector = () => {
  const user = useAtomValue(userAtom).data
  const isSuperAdmin = useAtomValue(userAtom).isSuperAdmin
  const isUser = useAtomValue(userAtom).isUser
  const myCompany = useAtomValue(userAtom).myCompany
  const loading = useAtomValue(userAtom).loading
  return {user, isSuperAdmin, isUser, myCompany, loading}
}
